import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNextDotJsComponent } from './simple-icons-next-dot-js.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNextDotJsComponent ],
    exports:      [ SimpleIconsNextDotJsComponent ],
    bootstrap:    []
})
export class SimpleIconsNextDotJsModule {}
